import { cn } from '../../utils/cn'

/**
 * Cai wordmark + twelve-bar symbol. All geometry below is sourced from
 * the canonical files in /logo — every large-size theme (black, white,
 * green, onDark) shares the exact same wordmark + symbol path data and
 * only swaps fill color, because that's how the source files are built.
 *
 * "onLight" (black wordmark + green symbol) was retired: it wasn't
 * legible once reproduced at small (nav/footer) scale. `black` is now
 * primary for light surfaces.
 */

const WORDMARK_LARGE =
  'M209.438 87.5479C239.464 87.5479 266.301 92.6141 289.947 102.747C313.969 112.88 334.237 126.391 350.752 143.279C367.267 159.792 379.089 177.994 386.221 197.885L317.534 229.973C309.652 208.956 296.328 191.692 277.562 178.182C258.795 164.296 236.086 157.353 209.438 157.353C183.164 157.353 159.893 163.545 139.625 175.93C119.732 188.314 104.156 205.391 92.8955 227.158C82.0109 248.925 76.5684 274.446 76.5684 303.719C76.5684 332.992 82.0109 358.699 92.8955 380.842C104.156 402.609 119.732 419.686 139.625 432.07C159.893 444.455 183.164 450.647 209.438 450.647C236.086 450.647 258.795 443.892 277.562 430.381C296.328 416.495 309.652 399.044 317.534 378.027L386.221 410.115C379.089 430.006 367.267 448.396 350.752 465.284C334.237 481.797 313.969 495.12 289.947 505.253C266.301 515.386 239.464 520.452 209.438 520.452C179.411 520.452 151.636 515.01 126.113 504.127C100.966 493.243 78.8209 478.044 59.6787 458.528C40.9119 439.013 26.2731 416.12 15.7637 389.85C5.25428 363.579 2.56307e-05 334.868 0 303.719C0 272.569 5.06709 243.859 15.2012 217.588C25.7106 190.942 40.3484 168.048 59.1152 148.908C78.2574 129.393 100.59 114.381 126.113 103.873C151.636 92.9895 179.411 87.5479 209.438 87.5479ZM567.874 200.699C593.021 200.699 615.167 205.391 634.309 214.773C653.451 223.781 668.276 236.541 678.785 253.054C689.67 269.191 695.112 288.144 695.112 309.911V513.697H625.3V481.581C621.413 485.864 617.285 489.814 612.914 493.431C602.029 502.062 589.643 508.818 575.756 513.697C561.869 518.201 546.48 520.452 529.59 520.452C508.196 520.452 489.616 516.887 473.852 509.757C458.088 502.626 445.89 492.493 437.257 479.357C428.624 465.847 424.308 450.272 424.308 432.633C424.308 415.745 428.061 400.733 435.567 387.598C443.074 374.087 454.71 362.827 470.474 353.82C486.238 344.813 506.131 338.434 530.152 334.681L621.359 319.822V309.911C621.359 296.776 616.104 285.892 605.595 277.26C595.461 268.253 581.949 263.749 565.059 263.749C549.294 263.749 535.219 268.065 522.833 276.697C510.822 284.954 502.002 296.025 496.372 309.911L436.131 280.638C442.136 264.5 451.52 250.614 464.281 238.979C477.418 226.97 492.807 217.587 510.447 210.832C528.088 204.077 547.231 200.699 567.874 200.699ZM837.034 513.697H763.28V207.455H837.034V513.697ZM544.228 389.286C529.589 391.913 518.705 396.605 511.573 403.36C504.442 410.116 500.876 418.935 500.876 429.818C500.876 440.327 504.817 448.77 512.699 455.15C520.957 461.155 531.091 464.158 543.102 464.158C558.49 464.158 572.002 460.968 583.638 454.588C595.648 447.833 604.844 438.638 611.225 427.004C617.981 415.37 621.359 402.609 621.359 388.724V376.18L544.228 389.286ZM837.034 173.115H763.28V94.3027H837.034V173.115Z'

const SYMBOL_LARGE =
  'M1303.57 -2.59163e-05L1379.57 -1.92721e-05L1379.57 205.2L1303.57 205.2L1303.57 -2.59163e-05ZM1212.38 68.3984L1288.38 68.3984L1288.38 205.198L1212.38 205.198L1212.38 68.3984ZM1121.19 121.601L1197.19 121.601L1197.19 205.201L1121.19 205.201L1121.19 121.601ZM1394.83 129.201L1486.02 129.201L1486.02 205.201L1394.83 205.201L1394.83 129.201ZM1394.8 220.399L1539.19 220.399L1539.19 296.399L1394.8 296.399L1394.8 220.399ZM992.001 220.401L1197.19 220.401L1197.19 296.401L992.001 296.401L992.001 220.401ZM1052.79 311.602L1197.18 311.602L1197.18 387.602L1052.79 387.602L1052.79 311.602ZM1394.81 311.603L1600 311.603L1600 387.603L1394.81 387.603L1394.81 311.603ZM1394.81 402.8L1470.81 402.8L1470.81 493.999L1394.81 493.999L1394.81 402.8ZM1212.45 608L1212.45 402.8L1288.45 402.8L1288.45 608L1212.45 608ZM1106.01 402.8L1197.21 402.8L1197.21 478.8L1106.01 478.8L1106.01 402.8ZM1303.64 402.802L1379.64 402.802L1379.64 547.201L1303.64 547.201L1303.64 402.802Z'

// Extra-small lockup — thicker bars, integer coordinates, tuned to stay
// crisp at nav/footer scale (~64x25). Do not substitute the large paths
// at small sizes: their finer gaps anti-alias into a blur below ~40px.
// Wordmark and symbol-bar geometry is shared across every small theme —
// the four "extra small" source files differ only in fill, with
// sub-pixel (5th-decimal) rounding noise between exports.
const WORDMARK_SMALL =
  'M8.26758 4.45605C9.4527 4.45609 10.512 4.65572 11.4453 5.05566C12.3935 5.45565 13.1938 5.98961 13.8457 6.65625C14.4974 7.30799 14.9637 8.02651 15.2451 8.81152L12.5342 10.0781C12.223 9.24852 11.6968 8.56652 10.9561 8.0332C10.2154 7.48531 9.31919 7.211 8.26758 7.21094C7.23061 7.21094 6.3117 7.4556 5.51172 7.94434C4.7265 8.43319 4.11146 9.1076 3.66699 9.9668C3.23733 10.826 3.02246 11.8337 3.02246 12.9893C3.0225 14.1446 3.23739 15.1592 3.66699 16.0332C4.11147 16.8924 4.72648 17.5668 5.51172 18.0557C6.31171 18.5444 7.23058 18.7891 8.26758 18.7891C9.31917 18.789 10.2154 18.5223 10.9561 17.9893C11.6968 17.4411 12.223 16.7515 12.5342 15.9219L15.2451 17.1885C14.9637 17.9735 14.4974 18.6997 13.8457 19.3662C13.1938 20.018 12.3935 20.5444 11.4453 20.9443C10.512 21.3443 9.45271 21.5439 8.26758 21.5439C7.08239 21.5439 5.98594 21.329 4.97852 20.8994C3.98585 20.4698 3.11108 19.87 2.35547 19.0996C1.61479 18.3293 1.03687 17.4256 0.62207 16.3887C0.207317 15.3518 3.29564e-05 14.2186 0 12.9893C0 11.7597 0.199581 10.6259 0.599609 9.58887C1.01442 8.53715 1.59231 7.63341 2.33301 6.87793C3.08862 6.10759 3.97104 5.51539 4.97852 5.10059C5.98592 4.67104 7.08241 4.45605 8.26758 4.45605ZM22.416 8.92285C23.4085 8.92286 24.2826 9.10732 25.0381 9.47754C25.7937 9.83308 26.3791 10.3374 26.7939 10.9893C27.2236 11.6262 27.4385 12.3742 27.4385 13.2334V21.2773H24.6826V20.0078C24.529 20.1772 24.3671 20.3345 24.1943 20.4775C23.7648 20.8182 23.2755 21.0848 22.7275 21.2773C22.1794 21.4551 21.571 21.5439 20.9043 21.5439C20.0602 21.5439 19.3271 21.4034 18.7051 21.1221C18.0828 20.8406 17.6005 20.4404 17.2598 19.9219C16.9192 19.3887 16.7491 18.7741 16.749 18.0781C16.749 17.4115 16.897 16.8183 17.1934 16.2998C17.4897 15.7665 17.9491 15.3223 18.5713 14.9668C19.1935 14.6113 19.9786 14.3591 20.9268 14.2109L24.5273 13.624V13.2334C24.5273 12.7149 24.3201 12.2851 23.9053 11.9443C23.5052 11.5888 22.9714 11.4111 22.3047 11.4111C21.6825 11.4112 21.1266 11.5812 20.6377 11.9219C20.1636 12.2478 19.816 12.6853 19.5938 13.2334L17.2158 12.0781C17.4529 11.4411 17.8234 10.8928 18.3271 10.4336C18.8457 9.9596 19.4531 9.5889 20.1494 9.32227C20.8457 9.05568 21.6013 8.92285 22.416 8.92285ZM33.041 21.2773H30.1289V9.18945H33.041V21.2773ZM21.4824 16.3662C20.9047 16.4699 20.4748 16.6552 20.1934 16.9219C19.9119 17.1885 19.7715 17.5372 19.7715 17.9668C19.7715 18.3815 19.9272 18.715 20.2383 18.9668C20.5642 19.2037 20.9645 19.3223 21.4385 19.3223C22.0457 19.3222 22.5789 19.1961 23.0381 18.9443C23.5122 18.6777 23.8751 18.3147 24.127 17.8555C24.3936 17.3963 24.5273 16.8927 24.5273 16.3447V15.8486L21.4824 16.3662ZM33.041 7.83398H30.1289V4.72266H33.041V7.83398Z'

const SYMBOL_BARS_SMALL = [
  'M47 4.00003L44 4.00003L44 8.00003L47 8.00003L47 4.00003Z',
  'M51 2.00003L48 2.00003L48 8.00003L51 8.00003L51 2.00003Z',
  'M55 3.10421e-05L52 3.05176e-05L52 8.00003L55 8.00003L55 3.10421e-05Z',
  'M60 7.99982L60 4.99982L56 4.99982L56 7.99982L60 7.99982Z',
  'M62 11.9998L62 8.99982L56 8.99982L56 11.9998L62 11.9998Z',
  'M64 15.9998L64 12.9998L56 12.9998L56 15.9998L64 15.9998Z',
  'M56 21.0001L59 21.0001L59 17.0001L56 17.0001L56 21.0001Z',
  'M52 23.0001L55 23.0001L55 17.0001L52 17.0001L52 23.0001Z',
  'M48 25.0001L51 25.0001L51 17.0001L48 17.0001L48 25.0001Z',
  'M43 17.0001L43 20.0001L47 20.0001L47 17.0001L43 17.0001Z',
  'M41 13.0001L41 16.0001L47 16.0001L47 13.0001L41 13.0001Z',
  'M39 9.00012L39 12.0001L47 12.0001L47 9.00012L39 9.00012Z',
]

// Standalone symbol mark — always safety-green, never black or white,
// regardless of `theme`. Distinct viewBox/geometry from the lockup's
// symbol half; no dedicated file for it exists yet in /logo.
// Exported so contexts that intentionally need a non-brand fill (e.g. a
// small icon glyph on a colored chip) can reuse the geometry directly
// without going through <Logo symbolOnly>, which always renders safety-green.
export const SYMBOL_ONLY = [
  'M205.397 121.719H129.323V205.4H205.397V121.719Z',
  'M296.681 68.4648H220.607V205.398H296.681V68.4648Z',
  'M387.965 0H311.892V205.399H387.965V0Z',
  'M494.531 205.4L494.531 129.326L403.243 129.326L403.243 205.4L494.531 205.4Z',
  'M547.752 296.687L547.752 220.613L403.212 220.613L403.212 296.687L547.752 296.687Z',
  'M608.627 387.978L608.627 311.904L403.228 311.904L403.228 387.978L608.627 387.978Z',
  'M114.133 403.19L114.133 479.264L205.421 479.264L205.421 403.19L114.133 403.19Z',
  'M60.8564 311.904L60.8564 387.977L205.396 387.977L205.397 311.904L60.8564 311.904Z',
  'M9.0717e-07 220.615L0 296.688L205.399 296.688L205.399 220.615L9.0717e-07 220.615Z',
  'M403.229 494.478L479.303 494.478L479.303 403.19L403.229 403.19L403.229 494.478Z',
  'M311.963 547.732L388.037 547.732L388.037 403.192L311.963 403.192L311.963 547.732Z',
  'M220.679 608.589L296.753 608.589L296.753 403.19L220.679 403.19L220.679 608.589Z',
]

/** `onDark` = white wordmark + green symbol. Every other theme is solid single-color. */
export type LogoTheme = 'black' | 'white' | 'green' | 'onDark'
export type LogoSize = 'default' | 'small'

export interface LogoProps {
  /**
   * "black" is primary, for light surfaces. "onDark" (white + green) is
   * the dark-surface counterpart. "white" and "green" are solid
   * single-color lockups for special placements (dark-surface footer,
   * single-color-only contexts).
   */
  theme?: LogoTheme
  /** "small" uses the simplified extra-small geometry — only affects rendering, all four themes have a small asset. */
  size?: LogoSize
  /** Render just the twelve-bar symbol, no wordmark. Safety-green unless a `theme` is passed. */
  symbolOnly?: boolean
  /** Rendered width in px; height follows the asset's native aspect ratio. */
  width?: number
  className?: string
  'aria-label'?: string
}

const LARGE_VIEWBOX = '0 0 1600 608'
const SMALL_VIEWBOX = '0 0 64 25'
export const SYMBOL_VIEWBOX = '0 0 609 609'
const LARGE_RATIO = 1600 / 608
const SMALL_RATIO = 64 / 25

const FILLS: Record<LogoTheme, { wordmark: string; symbol: string }> = {
  black: { wordmark: 'var(--ink)', symbol: 'var(--ink)' },
  white: { wordmark: 'var(--paper)', symbol: 'var(--paper)' },
  green: { wordmark: 'var(--brand)', symbol: 'var(--brand)' },
  onDark: { wordmark: 'var(--paper)', symbol: 'var(--brand)' },
}

export function Logo({
  theme,
  size = 'default',
  symbolOnly = false,
  width,
  className,
  'aria-label': ariaLabel = 'Cai',
}: LogoProps) {
  if (symbolOnly) {
    const w = width ?? 40
    return (
      <svg
        className={cn('block flex-none', className)}
        width={w}
        height={w}
        viewBox={SYMBOL_VIEWBOX}
        role="img"
        aria-label={ariaLabel}
        xmlns="http://www.w3.org/2000/svg"
      >
        {SYMBOL_ONLY.map((d) => (
          <path key={d} d={d} fill={theme ? FILLS[theme].symbol : 'var(--brand)'} />
        ))}
      </svg>
    )
  }

  const isSmall = size === 'small'
  const viewBox = isSmall ? SMALL_VIEWBOX : LARGE_VIEWBOX
  const ratio = isSmall ? SMALL_RATIO : LARGE_RATIO
  const w = width ?? (isSmall ? 64 : 220)
  const h = w / ratio
  const { wordmark: wordmarkFill, symbol: symbolFill } = FILLS[theme ?? 'black']

  return (
    <svg
      className={cn('block flex-none', className)}
      width={w}
      height={h}
      viewBox={viewBox}
      role="img"
      aria-label={ariaLabel}
      xmlns="http://www.w3.org/2000/svg"
    >
      {isSmall ? (
        <>
          <path d={WORDMARK_SMALL} fill={wordmarkFill} />
          {SYMBOL_BARS_SMALL.map((d) => (
            <path key={d} d={d} fill={symbolFill} />
          ))}
        </>
      ) : (
        <>
          <path d={WORDMARK_LARGE} fill={wordmarkFill} />
          <path d={SYMBOL_LARGE} fill={symbolFill} />
        </>
      )}
    </svg>
  )
}
